module.exports = __webpack_public_path__ + "img/tshirt2.063f19c5.png";